document.addEventListener('DOMContentLoaded', function () {
  const trigger = document.querySelector('[data-floating-video]');
  const modal = document.querySelector('[data-floating-video-modal]');
  if (!trigger || !modal) return;

  const thumbVideo = trigger.querySelector('.floating-video__thumb');
  const modalVideo = modal.querySelector('.floating-video-modal__player');
  const closeBtn = modal.querySelector('[data-fv-close]');
  const muteBtn = modal.querySelector('[data-fv-mute]');
  const playBtn = modal.querySelector('[data-fv-play]');

  function openModal() {
  modal.hidden = false;
  document.body.style.overflow = 'hidden';
  thumbVideo.pause();
  modalVideo.currentTime = 0;
  modalVideo.muted = false;
  modalVideo.play().catch(() => {
    modalVideo.muted = true;
    modalVideo.play();
    updateMuteIcon();
  });
  updatePlayIcon();
  updateMuteIcon();
}

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
    modalVideo.pause();
    thumbVideo.play().catch(() => {});
  }

  function updateMuteIcon() {
    muteBtn.textContent = modalVideo.muted ? '🔇' : '🔊';
  }

  function updatePlayIcon() {
    playBtn.textContent = modalVideo.paused ? '▶' : '⏸';
  }

  trigger.addEventListener('click', openModal);
  closeBtn.addEventListener('click', closeModal);

  muteBtn.addEventListener('click', () => {
    modalVideo.muted = !modalVideo.muted;
    updateMuteIcon();
  });

  playBtn.addEventListener('click', () => {
    if (modalVideo.paused) {
      modalVideo.play();
    } else {
      modalVideo.pause();
    }
    updatePlayIcon();
  });
});